var _circle, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStorage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18.047,
    cy: 18.325,
    r: 18.017,
    fill: "#3D60A2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#vl7mfqe8ba)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.742 7.848H8.882a.35.35 0 0 0-.349.349v19.558c0 .193.157.35.35.35h.698v.698h.699v-.699h3.492v.699h.698v-.699h1.397v.699h.699v-.699h3.492v.699h.699v-.699h1.397v.699h.699v-.699h3.492v.699h.699v-.699h.698a.35.35 0 0 0 .35-.349V8.197a.35.35 0 0 0-.35-.35zM14.82 27.406H9.232V8.546h5.588v18.86zm6.286 0h-5.588V8.546h5.588v18.86zm6.287 0h-5.588V8.546h5.588v18.86z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.772 9.594h-3.493v.698h3.493v-.698zM13.772 10.992h-3.493v.699h3.493v-.699zM13.772 12.389h-3.493v.698h3.493v-.698zM13.772 22.865h-3.493v.699h3.493v-.699zM13.772 24.262h-3.493v.698h3.493v-.698zM13.772 25.66h-3.493v.699h3.493v-.699zM10.978 16.23h-.699v.699h.699v-.698zM10.978 17.627h-.699v2.445h.699v-2.445zM20.058 9.594h-3.493v.698h3.493v-.698zM20.058 10.992h-3.493v.699h3.493v-.699zM20.058 12.389h-3.493v.698h3.493v-.698zM20.058 22.865h-3.493v.699h3.493v-.699zM20.058 24.262h-3.493v.698h3.493v-.698zM20.058 25.66h-3.493v.699h3.493v-.699zM17.264 16.23h-.699v.699h.699v-.698zM17.264 17.627h-.699v2.445h.699v-2.445zM26.344 9.594h-3.492v.698h3.492v-.698zM26.344 10.992h-3.492v.699h3.492v-.699zM26.344 12.387h-3.492v.698h3.492v-.698zM26.344 22.865h-3.492v.699h3.492v-.699zM26.344 24.262h-3.492v.698h3.492v-.698zM26.344 25.66h-3.492v.699h3.492v-.699zM23.55 16.23h-.698v.699h.698v-.698zM23.55 17.627h-.698v2.445h.698v-2.445z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "vl7mfqe8ba"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(7.834 7.848)",
    d: "M0 0h20.955v20.955H0z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStorage);
export default __webpack_public_path__ + "static/media/storage.45875aae6f2432caa911e409f2df5fdd.svg";
export { ForwardRef as ReactComponent };